import { render } from "./ExtRedirPage.vue?vue&type=template&id=524412de"
import script from "./ExtRedirPage.vue?vue&type=script&lang=js"
export * from "./ExtRedirPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__